import { PortfolioAllocation, PortfolioAllocationDataPoint } from '@models';
import { sortPortfolioDataPoints } from '@products/portfolio/portfolio.utils';
import {
  PortfolioAllocationFIDTO,
  PortfolioComponentId,
  PortfolioDTO,
} from '@types';
import { formatPercentage } from '@utils/text/number-utils';
import { MapperFactory } from '../mapper-factory';
import { getFirstNonEmptyProp, parseStdNumber, parseYN } from '../mapper.utils';
import { Mapper, MapperParams } from '../type.mapper';

// tslint:disable-next-line:max-line-length
// example fund: https://en-us.staging.ftsites.com/investments/options/exchange-traded-funds/products/18000/SINGLCLASS/franklin-liberty-short-duration-u-s-government-etf/FTSD#portfolio
export class PortfolioAllocationFIMapper extends Mapper<PortfolioAllocation[]> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(portfolioDto: PortfolioDTO): PortfolioAllocation[] {
    const data: PortfolioAllocationFIDTO[] = portfolioDto.portfolioallocationfi;

    // if no data, return null
    if (!data || data.length === 0) {
      return null;
    }
    const allocation: PortfolioAllocation = {
      componentId: PortfolioComponentId.MATURITY_ALLOCATION,
      baseLabelKey: 'maturity-allocation',
      allocationFlag: getFirstNonEmptyProp(data, 'allocflag'),
      allocationHeading: getFirstNonEmptyProp(data, 'allocheadinglocal'),
      asOfDate: getFirstNonEmptyProp(data, 'asofdate'),
      calculationBasis: getFirstNonEmptyProp(data, 'calcbasislocal'),
      calculationType: getFirstNonEmptyProp(data, 'calcname'),
      hasDerivatives: parseYN(getFirstNonEmptyProp(data, 'hasderivatives')),
      updateFrequency: getFirstNonEmptyProp(data, 'frequency'),
      data: data.sort(sortPortfolioDataPoints).map(
        (obj: PortfolioAllocationFIDTO): PortfolioAllocationDataPoint => ({
          label: obj.rangedesc,
          benchmark: formatPercentage(obj.bmbrkdwnpct),
          benchmarkStd: parseStdNumber(obj.bmbrkdwnpctstd),
          breakdown: formatPercentage(obj.brkdwnpct),
          breakdownStd: parseStdNumber(obj.brkdwnpctstd),
        })
      ),
    };
    return [allocation];
  }
}
